import React from 'react';

/**
 * Appkit 4 "expand-outline" icon, inlined as a React component so it can be
 * recolored via `currentColor` and styled with CSS.
 *
 * Source: Appkit4 icon set (Icon/Outline/expand-outline). The original
 * `fill="#474747"` has been replaced with `currentColor`.
 *
 * @param {React.SVGProps<SVGSVGElement>} props
 */
export default function ExpandOutlineIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      role="img"
      focusable="false"
      aria-hidden="true"
      {...props}
    >
      <g fill="currentColor" fillRule="nonzero">
        <path d="M0,0 L7.5,0 L7.5,1.5 L1.5,1.5 L1.5,7.5 L0,7.5 L0,0 Z M16.5000001,0 L24.0000001,0 L24.0000001,7.5 L22.5000001,7.5 L22.5000001,1.5 L16.5000001,1.5 L16.5000001,0 Z M22.5000001,16.5000001 L24.0000001,16.5000001 L24.0000001,24.0000001 L16.5000001,24.0000001 L16.5000001,22.5000001 L22.5000001,22.5000001 L22.5000001,16.5000001 Z M0,16.5000001 L1.5,16.5000001 L1.5,22.5000001 L7.5,22.5000001 L7.5,24.0000001 L0,24.0000001 L0,16.5000001 Z" />
      </g>
    </svg>
  );
}
